import TabsForTargets from './TabsForTargets'

export default TabsForTargets